<script setup lang="ts">
import type {
  AlertFilterDropdownables,
  AlertReportColumn,
  AlertReportFilter,
} from '../models/reports-bridge'
import { AlertReportFilters } from '../models/reports-bridge'

import { useI18n } from '@/shared/i18n'

defineProps<{
  filters: readonly AlertReportFilter[]
  columns: readonly AlertReportColumn[]
  dropdownables: AlertFilterDropdownables['dropdownables']['value']
  onLoadDropdownValues: AlertFilterDropdownables['loadDropdownValues']
  readOnly: boolean
}>()
const emit = defineEmits<{ 'update:filters': [filters: AlertReportFilter[]] }>()
const { t } = useI18n()
</script>

<template>
  <div class="alert-filter-step grid gap-md py-sm">
    <AlertReportFilters
      :model-value="filters"
      :columns="columns"
      :dropdownables="dropdownables"
      :on-load-dropdown-values="onLoadDropdownValues"
      variant="standalone"
      flex-col
      :label="t('alerts.fields.filters')"
      :disabled="readOnly"
      @update:model-value="emit('update:filters', $event)"
    />
    <p>{{ t('alerts.fields.filtersHint') }}</p>
  </div>
</template>

<style scoped>
.alert-filter-step p {
  margin: 0;
  color: var(--ui-color-muted);
  font-size: 0.75rem;
}
</style>
